import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';

import { Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class IoService {
  constructor(private socket: Socket) { }

  getDevices(cb): any {
    this.socket.connect();
    this.socket.emit('devices', null, cb);
  }

  getHeartbeat(): Observable<any> {
    this.socket.connect();
    return this.socket.fromEvent('heartbeat');
  }

  getDeviceEvents(device: string): Observable<any> {
    this.socket.connect();
    return this.socket.fromEvent('device_event_' + device);
  }

  removeListeners(): void {
    this.socket.removeAllListeners();
    this.socket.disconnect();
  }

}
